import { FC, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Lang, Team, TFile } from '@brg/api';
import styled, { css } from 'styled-components';
import { LayoutConst } from 'core';
import ProjectCardLayoutNew, { TitleMobile } from '../projectCard/projectCardLayoutNew';
import { ProjectCardContainerNew } from '../projectCard/stylesNew';
import { useAdBlockView } from '../../hooks/useAdBlockView';

export enum AdBlockViewType {
  WithCaption = 'with-caption',
  WithoutCaption = 'without-caption',
}

export interface IAdBlock {
  adBlockText?: any[];
  adBlockLink?: string | null;
  adBlockImages?: any[];
  adBlockImageContainerId?: string | null;
  adBlockOriginalImageInfo?: any;
  isHidden?: boolean;
  viewType?: string | null;
  position?: number;
}

export interface AdBlockCardProps {
  team?: Team;
  itemType?: string;
  currentTab?: string;
  onAdView?: () => void;
  fullWidth?: boolean;
  adBlock?: IAdBlock;
}

const toAdBlocks = (source: any): IAdBlock[] => {
  if (!source?.isShowAdBlock) return [];
  if (source.adBlocks?.length) {
    return source.adBlocks.filter((b: IAdBlock) => !b.isHidden);
  }
  return [];
};

export const getAdBlocks = (team: any, currentTab?: string): IAdBlock[] => {
  const tabs = team?.tabs || [];
  const tabData = currentTab
    ? tabs.find((tab: any) => tab.path === currentTab)
    : tabs.find((tab: any) => tab.isMain) || tabs[0];

  const tabBlocks = toAdBlocks(tabData);
  if (tabBlocks.length) return tabBlocks;

  return toAdBlocks(team);
};

export const getAdBlockGridIndex = (block: IAdBlock): number =>
  Math.max((block.position || 1) - 1, 0);

const PartnerBadge = styled.div`
  background: rgba(49, 49, 49, 0.4);
  border-radius: 3px;
  padding: 6px 18px;
  font-size: 12px;
  line-height: 1.2;
  color: #FFFFFF;
  backdrop-filter: blur(4px);
`;

const AdBlockContainer = styled.div<{ $hideCaption: boolean; $fullWidth?: boolean }>`
  display: contents;

  ${({ $hideCaption, $fullWidth }) => !$fullWidth && css`
    ${ProjectCardContainerNew} {
      height: auto;
      min-height: 0;
      max-height: none;
      aspect-ratio: ${$hideCaption ? '564 / 382' : '564 / 297'};
      box-shadow: none;
    }

    ${TitleMobile} {
      margin-top: 8px;

      div {
        font-size: 17px;
        line-height: 22px;

        @media (max-width: ${LayoutConst.screen.s - 1}px) {
          font-size: 15px;
          line-height: 20px;
        }
      }
    }
  `}
`;

export const AdBlockCard: FC<AdBlockCardProps> = ({ team, itemType, currentTab, onAdView, fullWidth, adBlock }) => {
  const { i18n, t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);
  const block = adBlock || getAdBlocks(team, currentTab)[0];
  const hideCaption = block?.viewType === AdBlockViewType.WithoutCaption;

  useAdBlockView({
    elementRef: containerRef,
    onAdView,
    disabled: !onAdView,
  });

  const adBlockCard = useMemo(() => {
    if (!block) return null;

    const adBlockTitle = Lang(block.adBlockText || [], i18n.language) || '';

    let titleImages: TFile[] | undefined = undefined;
    if (block.adBlockImages?.length) {
      //@ts-ignore
      const originalImage = block.adBlockImages.find((img: any) => img.size === 'original' || !img.size) || block.adBlockImages[0];
      titleImages = originalImage ? [originalImage] : undefined;
    }

    const topBadge = fullWidth ? t('text.partner_material_cap') : <PartnerBadge>{t('text.partner_material_cap')}</PartnerBadge>
    return (
      <ProjectCardLayoutNew
        key="ad-block-card"
        identifier={team?.teamId}
        title={hideCaption ? undefined : adBlockTitle}
        hideBelowCoverTitleAndAuthor={hideCaption}
        titleImages={titleImages}
        linkTo={block.adBlockLink || undefined}
        linkTarget="_blank"
        withoutGoToProject={!block.adBlockLink}
        projectType={'t-shape'}
        lmsCardType={'t-shape'}
        itemType={itemType}
        topBadge={topBadge}
        isPartnerMaterial={fullWidth}
      />
    );
  }, [block, hideCaption, team?.teamId, i18n.language, itemType, fullWidth, t]);

  if (!adBlockCard) return null;

  return (
    <AdBlockContainer ref={containerRef} $hideCaption={hideCaption} $fullWidth={fullWidth}>
      {adBlockCard}
    </AdBlockContainer>
  );
};

import { FC, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Lang, Team, TFile } from '@brg/api';
import styled, { css } from 'styled-components';
import { LayoutConst } from 'core';
import ProjectCardLayoutNew, { TitleMobile } from '../projectCard/projectCardLayoutNew';
import { ProjectCardContainerNew } from '../projectCard/stylesNew';
import { useAdBlockView } from '../../hooks/useAdBlockView';

export enum AdBlockViewType {
  WithCaption = 'with-caption',
  WithoutCaption = 'without-caption',
}

export interface IAdBlock {
  adBlockText?: any[];
  adBlockLink?: string | null;
  adBlockImages?: any[];
  adBlockImageContainerId?: string | null;
  adBlockOriginalImageInfo?: any;
  isHidden?: boolean;
  viewType?: string | null;
  position?: number;
}

export interface AdBlockCardProps {
  team?: Team;
  itemType?: string;
  currentTab?: string;
  onAdView?: () => void;
  fullWidth?: boolean;
  adBlock?: IAdBlock;
}

const toAdBlocks = (source: any): IAdBlock[] => {
  if (!source?.isShowAdBlock) return [];
  if (source.adBlocks?.length) {
    return source.adBlocks.filter((b: IAdBlock) => !b.isHidden);
  }
  return [];
};

export const getAdBlocks = (team: any, currentTab?: string): IAdBlock[] => {
  const tabs = team?.tabs || [];
  const tabData = currentTab
    ? tabs.find((tab: any) => tab.path === currentTab)
    : tabs.find((tab: any) => tab.isMain) || tabs[0];

  const tabBlocks = toAdBlocks(tabData);
  if (tabBlocks.length) return tabBlocks;

  return toAdBlocks(team);
};

export const getAdBlockGridIndex = (block: IAdBlock): number =>
  Math.max((block.position || 1) - 1, 0);

const PartnerBadge = styled.div`
  background: rgba(49, 49, 49, 0.4);
  border-radius: 3px;
  padding: 6px 18px;
  font-size: 12px;
  line-height: 1.2;
  color: #FFFFFF;
  backdrop-filter: blur(4px);
`;

const AdBlockContainer = styled.div<{ $hideCaption: boolean; $fullWidth?: boolean }>`
  display: contents;

  ${({ $hideCaption, $fullWidth }) => !$fullWidth && css`
    ${ProjectCardContainerNew} {
      height: auto;
      min-height: 0;
      max-height: none;
      aspect-ratio: ${$hideCaption ? '564 / 382' : '564 / 297'};
      box-shadow: none;
    }

    ${TitleMobile} {
      margin-top: 8px;

      div {
        font-size: 17px;
        line-height: 22px;

        @media (max-width: ${LayoutConst.screen.s - 1}px) {
          font-size: 15px;
          line-height: 20px;
        }
      }
    }
  `}
`;

export const AdBlockCard: FC<AdBlockCardProps> = ({ team, itemType, currentTab, onAdView, fullWidth, adBlock }) => {
  const { i18n, t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);
  const block = adBlock || getAdBlocks(team, currentTab)[0];
  const hideCaption = block?.viewType === AdBlockViewType.WithoutCaption;

  useAdBlockView({
    elementRef: containerRef,
    onAdView,
    disabled: !onAdView,
  });

  const adBlockCard = useMemo(() => {
    if (!block) return null;

    const adBlockTitle = Lang(block.adBlockText || [], i18n.language) || '';

    let titleImages: TFile[] | undefined = undefined;
    if (block.adBlockImages?.length) {
      //@ts-ignore
      const originalImage = block.adBlockImages.find((img: any) => img.size === 'original' || !img.size) || block.adBlockImages[0];
      titleImages = originalImage ? [originalImage] : undefined;
    }

    const topBadge = fullWidth ? t('text.partner_material_cap') : <PartnerBadge>{t('text.partner_material_cap')}</PartnerBadge>
    return (
      <ProjectCardLayoutNew
        key="ad-block-card"
        identifier={team?.teamId}
        title={hideCaption ? undefined : adBlockTitle}
        hideBelowCoverTitleAndAuthor={hideCaption}
        titleImages={titleImages}
        linkTo={block.adBlockLink || undefined}
        linkTarget="_blank"
        withoutGoToProject={!block.adBlockLink}
        projectType={'t-shape'}
        lmsCardType={'t-shape'}
        itemType={itemType}
        topBadge={topBadge}
        isPartnerMaterial={fullWidth}
      />
    );
  }, [block, hideCaption, team?.teamId, i18n.language, itemType, fullWidth, t]);

  if (!adBlockCard) return null;

  return (
    <AdBlockContainer ref={containerRef} $hideCaption={hideCaption} $fullWidth={fullWidth}>
      {adBlockCard}
    </AdBlockContainer>
  );
};

